export const APP_VERSION = '1.90.0';
